/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';

import Frame from '../frame';
import Style from './style';
import config from './config';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import { DEFAULT_FILTER_VALUE, filtersConfig } from './config';
import { useModule } from '../../../../../../../helpers/user';

const { Text } = Typography;

const Subjects = ({
  data = null,
  t = (t) => t,
}) => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [frameActions, setFrameActions] = useState(null);
  const [filtersActions, setFiltersActions] = useState(null);
  const { mod } = useModule();

  const renderValue = useCallback((subjectKey) => (
    activeFilter === 'all' ?
      <span>{data ? (data[subjectKey] ? data[subjectKey].total || '0' : '0') : '0'}</span> :
      <span>{data ? (data[activeFilter] ? data[activeFilter][subjectKey] || '0' : '0') : '0'}</span>
  ), [activeFilter, data]);

  useEffect(() => {
    if (data && frameActions) {
      frameActions.loading(false);
    } else if (frameActions) {
      frameActions.loading(true);
    }
  }, [data, frameActions]);

  const onFilterChangeHandler = useCallback((f) => setActiveFilter(f), []);

  useEffect(() => {
    if (activeFilter !== DEFAULT_FILTER_VALUE) {
      setActiveFilter(DEFAULT_FILTER_VALUE);
      if (filtersActions && filtersActions.resetValue) {
        filtersActions.resetValue();
      }
    }
  }, []);

  const filters = {
    ...filtersConfig,
    onInit: (outActions) => setFiltersActions(outActions),
  };

  return <Frame
    title={t('Identification')}
    filters={filters}
    onFilterChange={onFilterChangeHandler}
    onInit={actions => setFrameActions(actions)}
    doPopOver={false}
  >
    <Style>
      <div className="subjects-container">
        {config({ mod })[activeFilter].items.map((subject, j) => (
          <div className="subject-container" key={j.toString()}>
            <div className="icon section">
              {subject.icon}
            </div>
            <div className="value section">
              <Link target="_blank" rel="noopener noreferrer" to={subject.link}>
                {renderValue(subject.key)}
              </Link>
            </div>
            <div className="section">
              <Text
                ellipsis={{ tooltip: true }}
                className="title"
              >
                {t(subject.label)}
              </Text>
            </div>
          </div>
        ))}
      </div>
    </Style>
  </Frame>;
}

export default Subjects;
